import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { TopRowBox } from './TopRowBox';

export const TopRowFillPrice = observer(({ positionId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const position = tradePlanStore.positions.tradeUnafraid[positionId];
  if (!position)
    return (
      <TopRowBox
        backgroundColor={colors.grey}
        color={colors.lightGrey}
        width="100px"
      >
        Fill:
      </TopRowBox>
    );
  const fillPrice = position.avg_fill_price;
  return (
    <TopRowBox
      backgroundColor={colors.grey}
      color={colors.lightGrey}
      width="100px"
    >
      {`Fill: ${ApplyRounding(fillPrice, 2)}`}
    </TopRowBox>
  );
});
